<h1 class="title">BIM Models</h1>
<h5>Manage BIM models</h5>
<div class="cas-wrapper">
    <acabim-admin-view-bim-models #viewModel></acabim-admin-view-bim-models>
    <acabim-admin-create-bim-model (bimModelCreated)="viewModel.onNewModelCreated($event)"></acabim-admin-create-bim-model>
</div>
